import { graphConfig } from "./authConfig";

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callMsGraph(accessToken: string) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    try {
        // Fetch user profile data
        const userResponse = await fetch(graphConfig.graphMeEndpoint, options);
        
        if (!userResponse.ok) {
            throw new Error(`HTTP error! status: ${userResponse.status}`);
        }
        
        const userData = await userResponse.json();

        // Fetch user profile photo
        let photoUrl = "";
        try {
            const photoResponse = await fetch(graphConfig.graphMePhotoEndpoint, options);
            if (photoResponse.ok) {
                const photoBlob = await photoResponse.blob();
                photoUrl = URL.createObjectURL(photoBlob);
            }
        } catch (error) {
            console.warn("Could not fetch user photo:", error);
            // Photo is optional, continue without it
        }

        return {
            displayName: userData.displayName,
            mail: userData.mail || userData.userPrincipalName,
            jobTitle: userData.jobTitle,
            mobilePhone: userData.mobilePhone,
            officeLocation: userData.officeLocation,
            preferredLanguage: userData.preferredLanguage,
            surname: userData.surname,
            givenName: userData.givenName,
            id: userData.id,
            photo: photoUrl
        };
    } catch (error) {
        console.error("Error calling MS Graph:", error);
        throw error;
    }
}
